import type { PartnerSearchSchedulesParams, PartnerSchedule } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const schedules = {
  search: {
    queryKey: 'partner-management-service/schedules',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchSchedulesParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerSchedule[]>(
        '/partner-management-proxy/api/v1/partners/schedules',
        { params },
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/schedules/id',
    configurationType: 'no-cache' as const,
    fn: async (scheduleId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerSchedule>(
        `/partner-management-proxy/api/v1/partners/schedules/${scheduleId}`,
      );

      return data;
    },
  },
};
